var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReservoirError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 254,
    viewBox: "0 0 201 254",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_63_858)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54 5C54 3.34315 55.3431 2 57 2H137C138.657 2 140 3.34315 140 5V11.8625C140 13.5194 138.657 14.8625 137 14.8625H132V20.9622C149.232 21.3135 166.479 22.1373 183.765 23.6215C187.87 23.9739 191 27.4253 191 31.5455V235.972C191 240.393 187.438 243.975 183.017 243.973C166.035 243.961 125.562 243.941 97.2052 243.978C68.3512 244.016 27.1332 243.995 9.9724 243.984C5.55676 243.981 2 240.401 2 235.985V31.9043C2 27.6361 5.35102 24.1192 9.61428 23.9141C27.1098 23.0723 44.5635 22.2587 62 21.6681V14.8625H57C55.3431 14.8625 54 13.5194 54 11.8625V5Z",
    fill: "#DFEAED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132 14.8625V12.8625H130V14.8625H132ZM132 20.9622H130V22.9219L131.959 22.9618L132 20.9622ZM183.765 23.6215L183.594 25.6142L183.765 23.6215ZM183.017 243.973L183.016 245.973L183.017 243.973ZM97.2052 243.978L97.2026 241.978L97.2052 243.978ZM9.9724 243.984L9.97108 245.984H9.97109L9.9724 243.984ZM9.61428 23.9141L9.51816 21.9164H9.51816L9.61428 23.9141ZM62 21.6681L62.0677 23.667L64 23.6015V21.6681H62ZM62 14.8625H64V12.8625H62V14.8625ZM57 0C54.2386 0 52 2.23857 52 5H56C56 4.44772 56.4477 4 57 4V0ZM137 0H57V4H137V0ZM142 5C142 2.23858 139.761 0 137 0V4C137.552 4 138 4.44771 138 5H142ZM142 11.8625V5H138V11.8625H142ZM137 16.8625C139.761 16.8625 142 14.624 142 11.8625H138C138 12.4148 137.552 12.8625 137 12.8625V16.8625ZM132 16.8625H137V12.8625H132V16.8625ZM130 14.8625V20.9622H134V14.8625H130ZM183.937 21.6288C166.6 20.1403 149.309 19.3147 132.041 18.9626L131.959 22.9618C149.155 23.3123 166.358 24.1342 183.594 25.6142L183.937 21.6288ZM193 31.5455C193 26.4004 189.089 22.0712 183.937 21.6288L183.594 25.6142C186.652 25.8767 189 28.4503 189 31.5455H193ZM193 235.972V31.5455H189V235.972H193ZM183.016 245.973C188.549 245.976 193 241.49 193 235.972H189C189 239.295 186.327 241.975 183.018 241.973L183.016 245.973ZM97.2078 245.978C125.562 245.941 166.033 245.961 183.016 245.973L183.018 241.973C166.036 241.961 125.562 241.941 97.2026 241.978L97.2078 245.978ZM9.97109 245.984C27.1317 245.995 68.3516 246.016 97.2078 245.978L97.2026 241.978C68.3509 242.016 27.1346 241.995 9.97372 241.984L9.97109 245.984ZM0 235.985C0 241.498 4.44442 245.981 9.97108 245.984L9.97372 241.984C6.6691 241.982 4 239.304 4 235.985H0ZM0 31.9043V235.985H4V31.9043H0ZM9.51816 21.9164C4.18869 22.1728 0 26.5692 0 31.9043H4C4 28.7031 6.51336 26.0656 9.7104 25.9118L9.51816 21.9164ZM61.9323 19.6693C44.4803 20.2604 27.0142 21.0745 9.51816 21.9164L9.7104 25.9118C27.2054 25.07 44.6467 24.257 62.0677 23.667L61.9323 19.6693ZM64 21.6681V14.8625H60V21.6681H64ZM57 16.8625H62V12.8625H57V16.8625ZM52 11.8625C52 14.624 54.2386 16.8625 57 16.8625V12.8625C56.4477 12.8625 56 12.4148 56 11.8625H52ZM52 5V11.8625H56V5H52Z",
    fill: "#F75623"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_63_858",
    x: 0,
    y: 0,
    width: 201,
    height: 254,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.966667 0 0 0 0 0.336078 0 0 0 0 0.136944 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_63_858"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_63_858",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservoirError);
export default __webpack_public_path__ + "static/media/ReservoirError.7da758afbf4c6ae1e1be741668816c34.svg";
export { ForwardRef as ReactComponent };